import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { useMutation } from "@apollo/client";
import { useAuth, useToast } from "hooks";
import { Select } from "components/Form";
import { GET_ADMINS } from "graphql/queries";
import { UPDATE_PROFILE_ASSIGNEE } from "graphql/mutations";
import { PrimaryLink } from "components/Links";

/**
 * CandidateAssignmentSelector
 *
 * @param {Object}    profileData
 * @param {Boolean}   profileDataLoading
 */
const CandidateAssignmentSelector = ({ profileData, profileDataLoading }) => {
  const { toast } = useToast();
  const { id: currentId } = useAuth();
  const [assignee, { loading: saving }] = useMutation(UPDATE_PROFILE_ASSIGNEE);
  const [selection, setSelection] = useState(profileData?.profile?.assignedTo?.id);

  useEffect(() => {
    const assignedToId = profileData?.profile?.assignedTo?.id;

    setSelection(assignedToId);
  }, [profileData?.profile?.assignedTo?.id]);

  useEffect(() => {
    if (saving) return;

    const assignedToId = profileData?.profile?.assignedTo?.id;
    const profileId = profileData?.profile?.id;

    if (assignedToId != selection) {
      assignee({
        variables: {
          input: {
            profileId,
            assignedToId: selection,
          },
        },
        onCompleted: () => toast.success(<FormattedMessage id="Candidate.CandidateAssignmentSelector.Success" />),
        onError: () => toast.error(<FormattedMessage id="Candidate.CandidateAssignmentSelector.Error" />),
      });
    }
  }, [selection, profileData?.profile, saving]);

  return (
    <div css={styles.container}>
      <Select
        queryKeyName={"admins"}
        queryName={GET_ADMINS}
        placeholder="Unassigned"
        labelKey="name"
        valueKey="id"
        onChange={(name, val) => setSelection(val)}
        value={selection}
        loading={saving || profileDataLoading}
        isClearable
        disabled={profileDataLoading || saving}
      />
      <PrimaryLink onClick={() => setSelection(currentId)} disabled={saving} css={styles.link}>
        <FormattedMessage id="Candidate.CandidateAssignmentSelector.PrimaryLink.Text" />
      </PrimaryLink>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  link: css`
    order: 1;
    align-self: flex-end;
  `,
};

CandidateAssignmentSelector.propTypes = {
  profileData: PropTypes.object,
  profileDataLoading: PropTypes.bool,
};

export default CandidateAssignmentSelector;
